import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { LangList } from '@/shared/components/atoms/LanguageSelector/languagesList';
import { Typography } from '@/shared/components/atoms/Typography';
import ChangeLanguageModal from '@/shared/components/molecules/ChangeLanguageModal';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Language from '~/images/shared/Language.svg';

const LanguageSelector = ({ useName }: { useName?: boolean }) => {
  const { locale } = useRouter();
  const { t } = useTranslation('common');
  const { openModal } = useModal();

  return (
    <span
      onClick={() => {
        openModal(<ChangeLanguageModal />, {
          title: t('language'),
        });
      }}
      className='flex cursor-pointer items-center gap-2 rounded-lg p-2 hover:bg-outline-default hover:text-primary-400'
    >
      {useName ? (
        <>
          <div className='flex h-20 w-20 items-center justify-center overflow-hidden rounded-lg text-24'>
            <span>{locale && LangList[locale].flag}</span>
          </div>
          <div className='capitalize'>{locale ?? ''}</div>
        </>
      ) : (
        <>
          <Language />
          <Typography
            variant='subtitle2'
            weight='medium'
            className='text-text-default'
          >
            {t('language')}
          </Typography>
        </>
      )}
    </span>
  );
};
export default LanguageSelector;
